
function _getRootParent (products, product) {
	const parent = products.find(_product => _product.id === product.nearestParentId)
	if (parent) {
		return getRootParent(products, parent)
	}
	return product
}

export default {
	cartsMeta: state => state.cartsMeta,
	carts: state => state.carts,
	reservationsMeta: state => state.reservationsMeta,
	reservations: state => state.reservations,
	supplierOrderProducts: state => state.supplierOrderProducts,
	supplierOrders: state => state.supplierOrders,
	supplierOrdersMeta: state => state.supplierOrdersMeta,
	orders: state => state.orders,
	ordersMeta: state => state.ordersMeta,
	ordersProducts: state => state.ordersProducts,
	ordersProductsMeta: state => state.ordersProductsMeta,
	returningOrders: state => state.returningOrders,
	returningOrdersMeta: state => state.returningOrdersMeta,
	returningOrdersProducts: state => state.returningOrdersProducts,
	returningOrdersProductsMeta: state => state.returningOrdersProductsMeta,
	ordersProductsSortOrder: state => state.ordersProductsSortOrder,
	ordersProductsSortBy: state => state.ordersProductsSortBy,
	order: state => state.order ? {
		...state.order,
		oemOrder: true,
		isPaid: state.order.totalPrice <= state.order.subtotalPrice
	} : null,
	reservation: state => state.reservation ? {
		...state.reservation,
		oemReservation: true
	} : null,
	returningOrder: state => ({ ...state.returningOrder, returning: true }),
	statistics: state => state.statistics,
	meta: state => state.meta,
	ordersProductsColumns: state => state.ordersProductsColumns,
	ordersProductsOriginalColumns: state => state.ordersProductsOriginalColumns,
	products: state => state.products,
	productsBackup: state => state.productsBackup,
	productsMeta: state => state.productsMeta,
	reservationProducts: state => state.reservationProducts,
	reservationProductsBackup: state => state.reservationProductsBackup,
	reservationProductsMeta: state => state.reservationProductsMeta,
	returningProducts: state => state.returningProducts,
	returningProductsBackup: state => state.returningProductsBackup,
	returningProductsMeta: state => state.returningProductsMeta,
	loading: state => state.loading,
	searchFilters: state => state.searchFilters,
	reservationsSearchFilters: state => state.reservationsSearchFilters,
	supplierOrderSearchFilters: state => state.supplierOrderSearchFilters,
	returnInformation: state => state.returnInformation,
	dimensions: state => state.dimensions,
	trackingHistory: state => state.trackingHistory,
	reversedTrackingHistory: state => state.trackingHistory.reverse(),
	productsForShipment: state => {
		const targetProducts =
		state.ProductsTable.selected?.length ? state.ProductsTable.selected : state.products
		let _targetProducts = {}
		targetProducts
			.map(item => {
				if (item.isChild) {
					_targetProducts[item.id] = item
				}
				if (item.children) {
					item.children.map(child => {
						_targetProducts[child.id] = child
					})
				}
			})

		return Object.keys(_targetProducts).map(key => _targetProducts[key]).filter(item => !item.shipmentId && !item.shipment)
	}
}
